import React from 'react';
import "./Careers.css";
import { getStoredData } from '../../JsonFiles/fetchData';

// Importing components
import IntroTemplate from "../../components/IntroTemplate/IntroTemplate";
import SmallDescription from "../../components/SmallDescription/SmallDescription";
import CareerHiring from '../../components/CareerHiring/CareerHiring';
import OfficeImages from '../../components/OfficeImages/OfficeImages';
import SideIntro from "../../components/SideIntro/SideIntro";
import ContactUsForm from '../../components/ContactUsForm/ContactUsForm';

const Careers = () => {
  const data = getStoredData()?.["9"] ?? {};

  return (
    <div className="careers-container">
      <IntroTemplate logo={data.logo} title={data.title} image={data.image} />
      <SmallDescription title={data.smallTitle} details={data.SmallDetails}/>
      <OfficeImages data={data.OfficeImages}/>
      <SideIntro title={data.SideTitle} details={data.SideDetails} content={data.SideContent}/>
      <CareerHiring cards={data.CareerHiring}/>
      <ContactUsForm data={data.ContactContent}/>
    </div>
  );
};

export default Careers;
